import QuizService from 'src/modules/quiz/quizService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'QUIZ_RESULT_VIEW';

const quizResultViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (userId, id) => async (dispatch) => {
    try {
      dispatch({
        type: quizResultViewActions.FIND_STARTED,
      });

      const record = await QuizService.quizResultFind(userId, id);
      
      dispatch({
        type: quizResultViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizResultViewActions.FIND_ERROR,
      });

      getHistory().push('/user-answer-quiz');
    }
  },
};

export default quizResultViewActions;
